import { Text, Image, ButtonLink } from '@dsx/react';
import styles from './CollateralAssetView.module.css';
import type { UploadedAssetViewProps } from './types';

export const UploadedAssetView = ({
	category,
	headline,
	description,
	assetUrl,
	publishedDate,
	fileSize,
	fileExtension,
	createdDate,
	thumbnailImage,
	format,
}: UploadedAssetViewProps) => {
	return (
		<div className={styles['asset-detail-view']}>
			<div className={styles['content-container']}>
				{category && (
					<Text
						element="span"
						variant="highlight-1"
						className={styles['category']}
					>
						{category}
					</Text>
				)}
				{headline && (
					<Text
						element="h1"
						variant="display-headline-4"
						className={styles['headline']}
					>
						{headline}
					</Text>
				)}
				{description && (
					<Text
						element="p"
						variant="subtitle"
						className={styles['description']}
					>
						{description}
					</Text>
				)}
				<div className={styles['asset-details']}>
					{createdDate && (
						<Text element="p" variant="body-small">
							Published Date: {createdDate}
						</Text>
					)}
					{publishedDate && (
						<Text element="p" variant="body-small">
							Modified Date: {publishedDate}
						</Text>
					)}
					{format && (
						<Text element="p" variant="body-small">
							Format: {format}
						</Text>
					)}
					{fileExtension && (
						<Text element="p" variant="body-small">
							Extension: {fileExtension}
						</Text>
					)}
					{fileSize && (
						<Text element="p" variant="body-small">
							Size: {fileSize}
						</Text>
					)}
				</div>
				{assetUrl && (
					<ButtonLink
						href={assetUrl}
						variant="primary"
						target="_blank"
						className={styles['button']}
					>
						Download
					</ButtonLink>
				)}
			</div>
			<div className={styles['image-container']}>
				<Image
					src={thumbnailImage}
					alt="Collateral Asset Image"
					width="1000px"
					height="1000px"
					className={styles['image']}
				/>
			</div>
		</div>
	);
};
